import { TranslationService } from "../../../../services/TranslationService";
import { EditProps, strEvent } from "../EditAction";
import { Field } from "./FieldHelpers";

export const SMSTo = ({ propGen }: EditProps) => (
  <div className="row">
    <Field title={TranslationService.translate.SmsTo}>
      <input
        className="form-control"
        {...strEvent(propGen.str.notRequired("Mail_To"))}
      />
    </Field>
  </div>
);
